{
  "app-frame": {
    "buttons": {
      "be-partner": "Pro majitele salonů",
      "login": "Přihlášení",
      "logout": "Odhlášení",
      "my-appointments": "Moje schůzky",
      "my-salons": "Moje salony",
      "profile": "Profil",
      "read": "Přečtěte si",
      "sign-up": "Zaregistrujte se",
      "top-salons": "Nejlepší salony"
    },
    "text": {
      "agb-short": "VOP",
      "agb-updated-valid-since": "byly aktualizovány a budou platné od {{date}}",
      "click-to-read": "Klikněte pro přečtení"
    }
  }
}
